//这里就可以引用你要显示的页面了
const login = q => require.ensure([], () => q(require('../views/login')), 'login');
const index = q => require.ensure([], () => q(require('../views/index')), 'index').default;
const homePage = q => require.ensure([], () => q(require('../views/homepage')), 'homepage').default;

//工单中心
// const workIndex = q => require.ensure([], () => q(require('../views/work/index')), 'workIndex').default;
// const workIndexPage = q => require.ensure([], () => q(require('../views/work/index/homeIndex')), 'homeIndex').default;
//
// const workList = q => require.ensure([], () => q(require('../views/work/submit/list')), 'list').default; //工单提交列表
// const workDetails = q => require.ensure([], () => q(require('../views/work/submit/details')), 'details').default;
// const writeWork = q => require.ensure([], () => q(require('../views/work/submit/write')), 'write').default;
//
// const workMySubmit = q => require.ensure([], () => q(require('../views/work/mySubmit/list')), 'list').default; //我提交的列表
// const workSubmit = q => require.ensure([], () => q(require('../views/work/mySubmit/detail')), 'detail').default; //我提交详情
//
// const acceptWork = q => require.ensure([], () => q(require('../views/work/myAccept/list')), 'list').default; //我受理列表
// const acceptWkOrderDetail = q => require.ensure([], () => q(require('../views/work/myAccept/orderDetail')), 'orderDetail').default; //订单详请
// const acceptTraWkOrd = q => require.ensure([], () => q(require('../views/work/myAccept/transfer')), 'transfer').default; //ying
// const myAcceptWkOrderDetail = q => require.ensure([], () => q(require('../views/work/myAccept/detail')), 'detail').default; //受理详情
// const acceptRecord = q => require.ensure([], () => q(require('../views/work/acceptRecord/index')), 'index').default; //历史受理
// const acceptRecordDetail = q => require.ensure([], () => q(require('../views/work/acceptRecord/detail')), 'detail').default; //历史受理详情
//
// // 管理中心
// const questionSetting = q => require.ensure([], () => q(require('../views/privilege/questionSetting/list')), 'questionSetting').default; //ying
// const questionSettingAdd = q => require.ensure([], () => q(require('../views/privilege/questionSetting/add')), 'add').default; //ying
// const questionSettingUpdata = q => require.ensure([], () => q(require('../views/privilege/questionSetting/updata')), 'updata').default; //ying
// const questionGroupSetting = q => require.ensure([], () => q(require('../views/privilege/questionGroupSetting/list')), 'questionSetting').default; //ying
// const questionGroupSettingAdd = q => require.ensure([], () => q(require('../views/privilege/questionGroupSetting/add')), 'add').default; //ying
// const questionGroupSettingUpdata = q => require.ensure([], () => q(require('../views/privilege/questionGroupSetting/updata')), 'updata').default; //ying
//
// import demoList from "../views/demo/list";
// import demoAdd from "../views/demo/add";
// import example from '../views/demo/example'
// import demo from '../views/demo'
//配置路由，path就是你浏览器地址，component就是跟着你要显示的页面，/表示默认地址。
export default [
    {path: "/login", name: 'login', component: login},
    {path: "/health", name: 'health', component: () => import('../views/health')},
    {
        path: "/home",
        component: index,
        // redirect: "/work/workIndexPage",
        name: 'index',
        children: [
            {path: "/homepage", name: 'homepage', component: homePage},
            /*{
                name: 'work',
                path: 'work',
                component: workIndex,
                meta: { auth: true, title: '业务', icon: "el-icon-data-line" },
                children: [
                    { path: "/work/index/homeIndex", name: 'work.index.homeIndex', component: workIndexPage },
                    { path: "/work/submit/list", name: 'work.submit.list', component: workList },
                    // { path: "/work/submit/detail", name: 'work.submit.detail', component: workDetails },
                    { path: '/work/submit/write', name: 'work.submit.write', component: writeWork },
                    { path: '/work/mySubmit/list', name: 'work.mySubmit.list', component: workMySubmit },
                    { path: '/work/mySubmit/detail', name: 'work.mySubmit.detail', component: workSubmit },
                    { path: '/work/myAccept/list', name: 'work.myAccept.list', component: acceptWork },
                    { path: '/work/myAccept/transfer', name: 'work.myAccept.transfer', component: acceptTraWkOrd },
                    { path: '/work/myAccept/orderDetail', name: 'work.myAccept.orderDetail', component: acceptWkOrderDetail },
                    { path: '/work/myAccept/detail', name: 'work.myAccept.detail', component: myAcceptWkOrderDetail },
                    { path: '/work/acceptRecord/index', name: 'work.acceptRecord.index', component: acceptRecord },
                    { path: '/work/acceptRecord/detail', name: 'work.acceptRecord.detail', component: acceptRecordDetail },
                    // { path: '/work/mySubWkOrderDetail', name: 'work.mySubWkOrderDetail', component: mySubWkOrderDetail},acceptRecord
                ]
            },
            {
                name: "demo",
                path: "demo",
                component: demo,
                meta: { auth: true, title: 'demo' },
                children: [{
                        name: "demo.list",
                        path: "demo/list",
                        component: demoList,
                        meta: {
                            auth: true,
                            title: 'demo列表'
                        }
                    },
                    {
                        name: "demo.add",
                        path: "demo/add",
                        component: demoAdd,
                        meta: {
                            auth: true,
                            hide: true,
                            title: 'demo添加编辑'
                        }
                    },
                    {
                        name: "demo.example",
                        path: "example",
                        component: example,
                        meta: {
                            auth: true,
                            title: 'example'
                        }
                    }
                ]
            },
            {
                name: 'privilege',
                path: 'privilege',
                component: () =>
                    import ('../views/privilege/index'),
                redirect: 'privilege/privilege/list',
                meta: { auth: true, title: '管理中心' },
                children: [
                    //  {
                    //     name: 'privilege.menu.list',
                    //     path: 'menu/list',
                    //     component: () => import('../views/privilege/menu/list'),
                    //     meta: {
                    //         auth: true,
                    //         title: '菜单管理'
                    //     }
                    // },
                    // {
                    //     name: 'privilege.menu.details',
                    //     path: 'menu/details',
                    //     component: () => import('../views/privilege/menu/details'),
                    //     meta: {
                    //         auth: true,
                    //         hide: true,
                    //         title: '菜单'
                    //     }
                    // },
                    // {
                    //     name: 'privilege.user.list',
                    //     path: 'user/list',
                    //     component: () => import('../views/privilege/user/list'),
                    //     meta: {
                    //         auth: true,
                    //         title: '人员管理'
                    //     }
                    // },
                    // {
                    //     name: 'privilege.userGroup.add',
                    //     path: 'user/add',
                    //     component: () => import('../views/privilege/userGroup/add'),
                    //     meta: {
                    //         auth: true,
                    //         hide: true,
                    //         title: '新增'
                    //     }
                    // },
                    // {
                    //     name: 'privilege.role.list',
                    //     path: 'role/list',
                    //     component: () => import('../views/privilege/role/list'),
                    //     meta: {
                    //         auth: true,
                    //         hide: true,
                    //         title: '角色管理'
                    //     }
                    // },
                    // {
                    //     name: 'privilege.user.details',
                    //     path: 'user/details',
                    //     component: () => import('../views/privilege/user/details'),
                    //     meta: {
                    //         auth: true,
                    //         hide: true,
                    //         title: '菜单'
                    //     }
                    // },
                    {
                        name: 'privilege.questionSetting.list',
                        path: '/questionSetting/list',
                        component: questionSetting
                    },
                    {
                        name: 'privilege.questionSetting.add',
                        path: '/questionSetting/add',
                        component: questionSettingAdd
                    },
                    {
                        name: 'privilege.questionSetting.updata',
                        path: '/questionSetting/updata',
                        component: questionSettingUpdata
                    },
                    {
                        name: 'privilege.questionGroupSetting.list',
                        path: '/questionGroupSetting/list',
                        component: questionGroupSetting
                    },
                    {
                        name: 'privilege.questionGroupSetting.add',
                        path: '/questionGroupSetting/add',
                        component: questionGroupSettingAdd
                    },
                    {
                        name: 'privilege.questionGroupSetting.updata',
                        path: '/questionGroupSetting/updata',
                        component: questionGroupSettingUpdata
                    }
                ]
            },
            {
                name: 'workmange',
                path: 'workmange',
                component: () =>
                    import ('../views/privilege/index'),
                redirect: '/workmange/workOrderList',
                meta: { auth: true, title: '管理中心' },
                children: [{
                        name: 'workmange.workOrderList',
                        path: '/workmange/workOrderList',
                        component: () =>
                            import ('../views/workmange/workOrderList'),
                        redirect: '/workmange/workOrderList/list',
                        meta: {
                            auth: true,
                            title: '工单列表'
                        },
                        children: [{
                                name: 'workmange.workOrderList.list',
                                path: '/workmange/workOrderList/list',
                                component: () =>
                                    import ('../views/workmange/workOrderList/list'),
                                meta: {
                                    auth: true,
                                    hide: true,
                                    title: '工单列表表格'
                                },
                            },
                            {
                                name: 'workmange.workOrderList.detail',
                                path: '/workmange/workOrderList/detail',
                                component: () =>
                                    import ('../views/workmange/workOrderList/detail'),
                                meta: {
                                    auth: true,
                                    hide: true,
                                },
                            },
                            {
                                name: 'workmange.workOrderList.reply',
                                path: '/workmange/workOrderList/reply',
                                component: () =>
                                    import ('../views/workmange/workOrderList/reply'),
                                meta: {
                                    auth: true,
                                    hide: true,
                                },
                            },
                        ]
                    },
                    {
                        name: 'workmange.workQuality',
                        path: '/workmange/workQuality',
                        component: () =>
                            import ('../views/workmange/workQuality'),
                        redirect: '/workmange/workQuality/list',
                        meta: {
                            auth: true,
                            title: '工单质检'
                        },
                        children: [{
                                name: 'workmange.workQuality.list',
                                path: '/workmange/workQuality/list',
                                component: () =>
                                    import ('../views/workmange/workQuality/list'),
                                meta: {
                                    auth: true,
                                    title: '质检列表'
                                },
                            },
                            {
                                name: 'workmange.workQuality.detail',
                                path: '/workmange/workQuality/detail',
                                component: () =>
                                    import ('../views/workmange/workQuality/detail'),
                                meta: {
                                    auth: true,
                                    title: '质检详情'
                                },
                            },
                        ]
                    },
                    {
                        name: 'workmange.workQuality',
                        path: '/workmange/workQuality',
                        component: () =>
                            import ('../views/workmange/workQuality'),
                        redirect: '/workmange/workQuality/list',
                        meta: {
                            auth: true,
                            title: '工单质检'
                        },
                        children: [{
                                name: 'workmange.workQuality.list',
                                path: '/workmange/workQuality/list',
                                component: () =>
                                    import ('../views/workmange/workQuality/list'),
                                meta: {
                                    auth: true,
                                    title: '质检列表'
                                },
                            },
                            {
                                name: 'workmange.workQuality.detail',
                                path: '/workmange/workQuality/detail',
                                component: () =>
                                    import ('../views/workmange/workQuality/detail'),
                                meta: {
                                    auth: true,
                                    title: '质检详情'
                                },
                            },
                        ]
                    },
                    {
                        name: 'workmange.workQualitySetting',
                        path: '/workmange/workQualitySetting',
                        component: () =>
                            import ('../views/workmange/workQualitySetting'),
                        redirect: '/workmange/workQuality/list',
                        meta: {
                            auth: true,
                            title: '质检设置'
                        },
                        children: [{
                            name: 'workmange.workQualitySetting.setting',
                            path: '/workmange/workQualitySetting/setting',
                            component: () =>
                                import ('../views/workmange/workQualitySetting/setting'),
                        }, ]
                    },
                ]
            },
            {
                name: 'usermange',
                path: 'usermanange',
                component: () =>
                    import ('../views/usermange/index'),
                redirect: '/usermanange/loginManage',
                meta: { auth: true, title: '用户登录管理' },
                children: [{
                    name: 'usermange.loginManage',
                    path: '/usermange/loginManage',
                    component: () =>
                        import ('../views/usermange/loginManage'),
                    redirect: '/usermange/loginManage/userList',
                    meta: {
                        auth: true,
                        title: '用户登录管理'
                    },
                    children: [{
                            name: 'usermange.loginManage.userList',
                            path: '/usermange/loginManage/userList',
                            component: () =>
                                import ('../views/usermange/loginManage/userList'),
                            meta: {
                                auth: true,
                                hide: true,
                            },
                        },
                        {
                            name: 'usermange.loginManage.logList',
                            path: '/usermange/loginManage/logList',
                            component: () =>
                                import ('../views/usermange/loginManage/logList'),
                            meta: {
                                auth: true,
                                hide: true,
                            },
                        },
                    ]
                }, ]
            },*/
        ]
    },
    {path: "/404", name: 'notFind', component: () => import('../views/404')},
    // { path: "/", redirect: { name: "work.index.homeIndex" } },
]
